import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'

import CoreResize from '../../mixins/core-resize'

import URL from '../../../config.url'

export default
{
    name: 'app-gallery-slideshow',

    mixins: [
        CoreResize
    ],

    components: {
        AppBtnShare,
        AppImgBg
    },

    props:
    {
        isActive: { type: Boolean, default: false },
        images: { type: Array, default: [] },
        activeImage: { type: Object, default: {} },
        contentPage: { type: Object, default: {} }
    },

    data()
    {
        return {
            imagesWidth: [],
            activeIndex: 0,
            URL,
            isZoomed: false
        }
    },

    watch:
    {
        isActive: 'onIsActiveChange',
        images: 'onImagesChange',
        activeImage: 'onActiveImageChange',
        activeIndex: 'onActiveIndexChange',
        isZoomed: 'onIsZoomedChange'
    },

    created()
    {
        this.imagesLoaded = 0

        this.PIXEL_STEP = 10

        this.imagesOriginal = this.images

        // Mousewheel
        this._isWheeling = false
        this._isPointerDown = false
        this._pointerY = 0
        this._pointerStartY = 0
        //

        this.time = new Date()
        this.timeTreshold = 150 // in ms

        this.timeZoom = new Date()

        document.addEventListener('keydown', this.handleKeydown)

        this.eventHub.$on('application:on-frame', this.onFrame)
        this.eventHub.$on('app-gallery-slideshow:toggle-is-zoomed', this._toggleIsZoomed)

        this.eventHub.$on('app-img-bg:image-loaded', this.imageLoaded)
    },

    mounted()
    {
        this.$images = this.$el.querySelectorAll('.js-slideshow-image-container')

        this.$images.forEach((image, index) =>
        {
            this.$images[index].classList.add('is-loading')

            image.addEventListener('mousemove', event =>
            {
                this._onMousemoveOnImage(event, image, index)
            })
        })

        if (this.activeImage)
        {
            for (let i = 0, l = this.images.length; i < l; i += 1)
            {
                if (this.images[i].id === this.activeImage.id)
                {
                    this.activeIndex = i
                }
            }
        }
        else
        {
            this.onActiveIndexChange()
        }
    },

    destroyed()
    {
        this.eventHub.$off('application:on-frame', this.onFrame)
        this.eventHub.$off('app-gallery-slideshow:toggle-is-zoomed', this._toggleIsZoomed)

        this.eventHub.$off('app-img-bg:image-loaded', this.imageLoaded)

        this.$images.forEach((image, index) =>
        {
            image.addEventListener('mousemove', event =>
            {
                this._onMousemoveOnImage(event, image, index)
            })
        })

        document.removeEventListener('keydown', this.handleKeydown)
    },

    methods:
    {
        setImagesSizeAndPosition()
        {
            this.$images.forEach((image, index) =>
            {
                const containerWidth = image.offsetWidth / 2
                const containerHeight = image.offsetHeight / 2
                const containerRatio = containerWidth / containerHeight

                const imageRatio =
                    this.imagesOriginal[index].width / this.imagesOriginal[index].height

                const translateX = '20%'

                // const scale = imageRatio < 1 ? 1 : Math.abs(imageRatio - containerRatio) + 1
                let scale = 1

                if (imageRatio > containerRatio)
                {
                    scale = (imageRatio - containerRatio) + 1
                }

                if (imageRatio < 1)
                {
                    // Portrait image
                    if (containerRatio < 1)
                    {
                        // Portrait container
                        scale = imageRatio / containerRatio + 1
                    }
                    else
                    {
                        // Landscape container
                    }
                }
                else
                {
                    // Landscape image
                    if (containerRatio < 1)
                    {
                        // Portrait container
                        scale = imageRatio / containerRatio
                    }
                    else
                    {
                        // Landscape container
                    }
                }

                // if (imageRatio > 1)
                // {
                if (index <= this.activeIndex - 2)
                {
                    if (this.$root.width > 940)
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(calc(${translateX} * 2)) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                    else
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(50%) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                }
                else if (index === this.activeIndex - 1)
                {
                    if (this.$root.width > 940)
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(${translateX}) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                    else
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(50%) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                }
                else if (index === this.activeIndex)
                {
                    if (this.$root.width > 940)
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(0) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                    else
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(0) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                }
                else if (index === this.activeIndex + 1)
                {
                    if (this.$root.width > 940)
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(calc(${translateX} * -1)) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                    else
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(-50%) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                }
                else if (index >= this.activeIndex + 2)
                {
                    if (this.$root.width > 940)
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(calc(${translateX} * -1 * 2)) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                    else
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(-50%) translateY(-50%) scale(${scale}) translateZ(0)`
                    }
                }
                // }
            })
        },

        // WATCHERS
        onImagesChange()
        {
            this.imagesOriginal = this.images

            this.$nextTick(() =>
            {
                this.$images = this.$el.querySelectorAll('.js-slideshow-image-container')

                this.onActiveIndexChange()
            })
        },

        onIsActiveChange()
        {
            if (this.isActive)
            {
                document.body.classList.add('u-overflow-h')
            }
            else
            {
                document.body.classList.remove('u-overflow-h')
            }
        },

        onActiveImageChange()
        {
            if (this.activeImage)
            {
                this.images.forEach((image, index) =>
                {
                    if (this.activeImage.key === image.key
                        && this.activeImage.src === image.src
                        && this.activeImage.slug === image.slug
                        && this.activeImage.title === image.title)
                    {
                        this.activeIndex = index
                    }
                })
            }
        },

        setImagesContainerSizeAndPosition()
        {
            // this.$images.forEach((image, index) =>
            for (let index = 0, l = this.$images.length; index < l; index += 1)
            {
                const image = this.$images[index]

                if (index <= this.activeIndex - 2)
                {
                    // Left left
                    if (this.$root.width < 940)
                    {
                        // Screen < 940px
                        image.style.zIndex = 0

                        image.style.transform = `translateX(-${Math.round(this.$root.width / 100 * 180) - 1}px) translateY(-50%) scale(1) translateZ(0)`
                    }
                    else
                    {
                        image.style.zIndex = 0

                        image.style.transform = `translateX(-${Math.round(this.$root.width / 100 * 90) - 1}px) translateY(-50%) scale(0.5) translateZ(0)`
                    }
                }
                else if (index === this.activeIndex - 1)
                {
                    // Left
                    if (this.$root.width < 940)
                    {
                        // Screen < 940px
                        image.style.zIndex = 0

                        image.style.transform = `translateX(-${Math.round(this.$root.width / 100 * 90) - 1}px) translateY(-50%) scale(1) translateZ(0)`
                    }
                    else
                    {
                        image.style.zIndex = 0

                        image.style.transform = `translateX(-${Math.round(this.$root.width / 100 * 50) - 1}px) translateY(-50%) scale(0.5) translateZ(0)`
                    }
                }
                else if (index === this.activeIndex)
                {
                    // Active
                    if (this.$root.width < 940)
                    {
                        // Screen < 940px
                        image.style.zIndex = 2

                        image.style.transform = 'translateX(0) translateY(-50%) scale(1) translateZ(0)'
                    }
                    else
                    {
                        image.style.zIndex = 2

                        image.style.transform = 'translateX(0) translateY(-50%) scale(0.5) translateZ(0)'
                    }
                }
                else if (index === this.activeIndex + 1)
                {
                    // Right
                    if (this.$root.width < 940)
                    {
                        // Screen < 940px
                        image.style.zIndex = 0

                        image.style.transform = `translateX(${Math.round(this.$root.width / 100 * 90) - 1}px) translateY(-50%) scale(1) translateZ(0)`
                    }
                    else
                    {
                        image.style.zIndex = 0

                        image.style.transform = `translateX(${Math.round(this.$root.width / 100 * 50) - 1}px) translateY(-50%) scale(0.5) translateZ(0)`
                    }
                }
                else if (index >= this.activeIndex + 2)
                {
                    // Right right
                    if (this.$root.width < 940)
                    {
                        // Screen < 940px
                        image.style.zIndex = 0

                        image.style.transform = `translateX(${Math.round(this.$root.width / 100 * 180) - 1}px) translateY(-50%) scale(1) translateZ(0)`
                    }
                    else
                    {
                        image.style.zIndex = 0

                        image.style.transform = `translateX(${Math.round(this.$root.width / 100 * 90) - 1}px) translateY(-50%) scale(0.5) translateZ(0)`
                    }
                }
            }
            // })
        },

        onActiveIndexChange()
        {
            if (this.activeIndex >= 0 && this.activeIndex < this.imagesOriginal.length)
            {
                if (this.isActive)
                {
                    this.$router.push(`${this.$root.getPageURLFromID('gallery')}/${this.images[this.activeIndex].slug}`)
                }

                this.setImagesSizeAndPosition()

                this.setImagesContainerSizeAndPosition()
            }
        },

        onIsZoomedChange()
        {
            if (this.$root.width > 940)
            {
                const image = this.$images[this.activeIndex]

                if (image && this.isZoomed)
                {
                    // If image exists and it's zoomed
                    image.style.zIndex = 2

                    image.style.transform = 'translateY(-50%) translateZ(0)'

                    this.zoomOutLaunched = false

                    if (this.images[this.activeIndex].width >= this.$root.width)
                    {
                        image.querySelector('.js-slideshow-image').style.transform = 'translateX(0) translateY(-50%) scale(1) translateZ(0)'
                    }
                    else
                    {
                        image.querySelector('.js-slideshow-image').style.transform = `translateX(0) translateY(-50%) scale(${this.images[this.activeIndex].width / this.$root.width}) translateZ(0)`
                    }
                }
                else if (image)
                {
                    image.style.zIndex = 2

                    image.style.transform = 'translateX(0) translateY(-50%) scale(0.5) translateZ(0)'

                    this.setImagesSizeAndPosition()

                    this.zoomOutLaunched = true

                    this.timeZoom = new Date()
                }
            }
        },

        onFrame()
        {
            if (this.zoomOutLaunched)
            {
                const time = new Date()

                if (time - this.timeZoom > 1000)
                {
                    this.timeZoom = new Date()

                    this.zoomOutLaunched = false

                    this.$images[this.activeIndex].style.zIndex = 1
                }
            }

            this.eventHub.$emit('page-gallery:get-is-zoomed', this.isZoomed)
        },

        imageLoaded(image)
        {
            this.imagesLoaded += 1

            this.imagesOriginal = this.imagesOriginal.map((img, index) =>
            {
                if (image.src === img.src)
                {
                    img.width = image.width
                    img.height = image.height

                    if (img.width > this.$root.width)
                    {
                        this.$images[index].classList.add('is-can-be-zoomed')
                    }
                }

                return img
            })

            if (this.imagesLoaded === this.imagesOriginal.length)
            {
                this.setImagesSizeAndPosition()

                this.$images.forEach(img =>
                {
                    img.classList.remove('is-loading')
                })
            }
        },

        _toggleIsZoomed(value = !this.isZoomed)
        {
            this.isZoomed = value
        },

        // HANDLERS
        handleKeydown(event)
        {
            const time = new Date()

            if (time - this.time > this.timeTreshold)
            {
                this.time = new Date()

                if (event.keyCode === 37)
                {
                    this.goToPrev()
                }
                else if (event.keyCode === 39)
                {
                    this.goToNext()
                }
            }
        },

        _onMousemoveOnImage(event, image, index)
        {
            if (this.activeIndex === index
                && this.isZoomed
                && (this.images[this.activeIndex].width >= this.$root.width
                    || this.images[this.activeIndex].height >= this.$root.height)
                )
            {
                let percent = 0
                let translateY = 0

                if (this.images[this.activeIndex].width / this.images[this.activeIndex].height
                    < this.$root.width / this.$root.height)
                {
                    percent = ((event.clientY - (this.$root.height / 2)) / this.$root.height) * 2

                    if (this.images[this.activeIndex].width >= this.$root.width)
                    {
                        translateY = (image.querySelector('.js-slideshow-image').offsetHeight - this.$root.height) / 2 * percent
                    }
                    else
                    {
                        translateY = ((image.querySelector('.js-slideshow-image').offsetHeight * (this.images[this.activeIndex].width / this.$root.width)) - this.$root.height) / 2 * percent
                    }
                }

                if (translateY < 0)
                {
                    translateY -= this.$root.height / 10
                }
                else if (translateY > 0)
                {
                    translateY += this.$root.height / 10
                }

                if (this.images[this.activeIndex].width >= this.$root.width)
                {
                    image.querySelector('.js-slideshow-image').style.transform = `translateY(calc(-50% - ${translateY}px)) scale(1) translateZ(0)`
                }
                else
                {
                    image.querySelector('.js-slideshow-image').style.transform = `translateY(calc(-50% - ${translateY}px)) scale(${this.images[this.activeIndex].width / this.$root.width}) translateZ(0)`
                }
            }
        },

        // ACTIONS
        goToPrev()
        {
            if (this.activeIndex === 0 || this.isZoomed) return

            this.activeIndex -= 1
        },

        goToNext()
        {
            if (this.activeIndex === this.imagesOriginal.length - 1 || this.isZoomed) return

            this.activeIndex += 1
        },

        // ACTIONS FROM HTML
        _hideSlideshow()
        {
            this.eventHub.$emit('page-gallery:toggle-is-slideshow-hidden')
        },

        _changeActiveIndexTo(index)
        {
            if (index < 0 || index > this.imagesOriginal.length - 1) return

            if (index === this.activeIndex)
            {
                this.isZoomed = !this.isZoomed
            }

            this.activeIndex = index
        },

        // SCROLL ACTIONS
        onMouseWheel(event)
        {
            event.preventDefault()
            event.stopPropagation()

            clearTimeout(this.wheelTimer)
            this.wheelTimer = setTimeout(() =>
            {
                this._isWheeling = false
            }, 100)


            if (Math.abs(-this.normalizeWheel(event).pixelY) < 20)
            {
                clearTimeout(this.wheelTimer)
                this._isWheeling = false
            }

            if (this._isWheeling
                || Math.abs(-this.normalizeWheel(event).pixelY) < 20
                || Date.now() - this._lastWheelTime < 750)
            {
                return
            }

            this._lastWheelTime = Date.now()

            this._wheelEndTimer = setTimeout(() =>
            {
                clearTimeout(this.wheelTimer)
                this._isWheeling = false
            }, 1000)

            this._isWheeling = true

            this._isScrollFromWheel = true

            const normalizeWheel = this.normalizeWheel(event)
            const wheelDeltaY = -normalizeWheel.pixelY
            const delta = wheelDeltaY

            if (delta < 0)
            {
                this.goToNext()
            }
            else if (delta > 0)
            {
                this.goToPrev()
            }
        },

        onTouchDown(event)
        {
            this._isPointerDown = true

            this._pointerStartY = event.touches[0].clientY
            this._pointerStartX = event.touches[0].clientX

            this._pointerY = this._pointerStartY
            this._pointerX = this._pointerStartX
        },

        onTouchMove(event)
        {
            if (!this._isPointerDown) return

            event.preventDefault()

            this._pointerY = event.touches[0].clientY
            this._pointerX = event.touches[0].clientX
        },

        onTouchEnd(/* event */)
        {
            if (!this._isPointerDown) return

            this._isPointerDown = false

            if (Math.abs(this._pointerStartX - this._pointerX) > 10)
            {
                if (this._pointerX > this._pointerStartX)
                {
                    this.goToPrev()
                }
                else
                {
                    this.goToNext()
                }
            }
        },

        normalizeWheel(event)
        {
            this._sX = 0
            this._sY = 0 // spinX, spinY

            this._pX = 0
            this._pY = 0 // pixelX, pixelY

            // Legacy
            if ('detail' in event)
            {
                this._sY = event.detail
            }
            if ('wheelDelta' in event)
            {
                this._sY = -event.wheelDelta / 120
            }
            if ('wheelDeltaY' in event)
            {
                this._sY = -event.wheelDeltaY / 120
            }
            if ('wheelDeltaX' in event)
            {
                this._sX = -event.wheelDeltaX / 120
            }

            // side scrolling on FF with DOMMouseScroll
            if ('axis' in event && event.axis === event.HORIZONTAL_AXIS)
            {
                this._sX = this._sY
                this._sY = 0
            }

            this._pX = this._sX * this.PIXEL_STEP
            this._pY = this._sY * this.PIXEL_STEP

            if ('deltaY' in event)
            {
                this._pY = event.deltaY
            }
            if ('deltaX' in event)
            {
                this._pX = event.deltaX
            }

            if ((this._pX || this._pY) && event.deltaMode)
            {
                if (event.deltaMode == 1)
                {
                    // delta in LINE units
                    this._pX *= this.LINE_HEIGHT
                    this._pY *= this.LINE_HEIGHT
                }
                else
                {
                    // delta in PAGE units
                    this._pX *= this.PAGE_HEIGHT
                    this._pY *= this.PAGE_HEIGHT
                }
            }

            // Fall-back if spin cannot be determined
            if (this._pX && !this._sX)
            {
                this._sX = (this._pX < 1) ? -1 : 1
            }
            if (this._pY && !this._sY)
            {
                this._sY = (this._pY < 1) ? -1 : 1
            }

            return {
                spinX: this._sX,
                spinY: this._sY,
                pixelX: this._pX,
                pixelY: this._pY
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-gallery-slideshow/script.js